import React, { useState, useEffect } from "react";
import Select from "react-select";
import cloneDeep from "lodash/cloneDeep";
import findIndex from "lodash/findIndex";

import "./Deductions.scss";
import axios from "axios";
import Loader from "../../../../../../components/loader";

const DeductionsView = (props) => {

  const { USER, savedEarningsCodes, companyId, companyShortName } = props;

  const [deductionsList, updateDeductionsList] = useState([]);
  const [selectedDeductionsList, updateSelectedDeductionsList] = useState([]);
  const [loading, setLoading] = useState();

  const populateList = async () => {
    setLoading(true);

    let d = await axios.get(`api/deduction-codes/deductions-list/${companyShortName}`)

    updateDeductionsList(d.data || []);

    updateSelectedDeductionsList(savedEarningsCodes?.dc || []);

    setLoading(false);
  };

  const updateSelected = (option) => {
    if (deductionsList.length) {
      const index = deductionsList.indexOf(option);
      deductionsList.splice(index, 1);
      updateDeductionsList(deductionsList);
      return updateSelectedDeductionsList([
        ...selectedDeductionsList,
        { ...option, negate: false },
      ]);
    }

  };

  const removeFromSelected = (itm) => {
    let itmCopy = cloneDeep(itm);
    updateDeductionsList([...deductionsList, itmCopy]);
    let copy = cloneDeep(selectedDeductionsList);
    let index = findIndex(copy, { label: itmCopy.label });
    copy.splice(index, 1);

    return updateSelectedDeductionsList([...copy]);
  };

  useEffect(() => {
    if (USER) {
      populateList();
    }
    // eslint-disable-next-line
  }, [USER]);

  const updateNegate = (value, idx) => {
    let copy = cloneDeep(selectedDeductionsList);
    copy[idx].negate = value;
    return updateSelectedDeductionsList(copy);
  };
  return (
    <>
      {loading ? (
        <Loader></Loader>
      ) : (
        <div className="ddctns_page df align-items-center justify-content-between">
          <div className="dd_wrpr">
            <Select
              placeholder="Select"
              options={deductionsList}
              //   value={this.state.ccIndex}
              onChange={updateSelected}
            />
          </div>
          {selectedDeductionsList.map((selectedOption, idx) => (
            <div className="df acsa ddctn_wrpr" key={idx}>
              {selectedOption.label}

              <div className="chbx_sec_wrpr">
                <input
                  type="checkbox"
                  id={`negate_${idx + 1}`}
                  checked={selectedOption.negate}
                  onChange={(e) => updateNegate(e.target.checked, idx)}
                ></input>
                <label htmlFor={`negate_${idx + 1}`}>Negate</label>
              </div>
              <p
                className="mla"
                onClick={() => removeFromSelected(selectedOption)}
              >
                delete
              </p>
            </div>
          ))}
          <button className="btn reportBtn" disabled={!selectedDeductionsList.length}
            onClick={() =>
              axios.post("api/wage-parity/earnings-codes", {
                dc: selectedDeductionsList,
                companyId: companyId,
              })
            }
          >
            Save
          </button>
        </div>
      )}
    </>
  );
};

export default DeductionsView;
